/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbpPtwExceptionHttpResponseModelData } from './AbpPtwExceptionHttpResponseModelData';
import {
    AbpPtwExceptionHttpResponseModelDataFromJSON,
    AbpPtwExceptionHttpResponseModelDataFromJSONTyped,
    AbpPtwExceptionHttpResponseModelDataToJSON,
} from './AbpPtwExceptionHttpResponseModelData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100BadGatewayException
 */
export interface Ptw100BadGatewayException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {AbpPtwExceptionHttpResponseModelData}
     * @memberof Ptw100BadGatewayException
     */
    data?: AbpPtwExceptionHttpResponseModelData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100BadGatewayException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100BadGatewayException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100BadGatewayException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100BadGatewayException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadGatewayException
     */
    $type?: Ptw100BadGatewayExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100BadGatewayExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100BadGatewayExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100BadGatewayException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100BadGatewayExceptionTypeEnum = typeof Ptw100BadGatewayExceptionTypeEnum[keyof typeof Ptw100BadGatewayExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100BadGatewayException interface.
 */
export function instanceOfPtw100BadGatewayException(value?: unknown): value is Ptw100BadGatewayException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100BadGatewayExceptionTypeEnum)[0];
}

export function Ptw100BadGatewayExceptionFromJSON(json: any): Ptw100BadGatewayException {
    return Ptw100BadGatewayExceptionFromJSONTyped(json, false);
}

export function Ptw100BadGatewayExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100BadGatewayException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AbpPtwExceptionHttpResponseModelDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100BadGatewayExceptionToJSON(value?: Omit<Ptw100BadGatewayException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': AbpPtwExceptionHttpResponseModelDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

